const styles = () => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    width: '100%',
    minHeight: '100%',
    background: '#333',
  },

  container: {
    background: 'white',
    color: '#333',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 50,
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 10,
    boxShadow: '0 1px 2px 0 #333',
  },

  logo: {
    marginBottom: 30,
    width: 60,
    height: 60,
    animation: 'rotate 5s linear infinite',
  },

  title: {
    marginBottom: 10,
    fontSize: 24,
    fontWeight: 'bold',
  },

  text: {
    marginBottom: 10,
  },
});

export default styles;
